import { useFeatureFlagFilter } from "featureflag";

import { Access, ACCESS_MAP, AppDestination } from "./accessMap";

/** A destination the flag has pruned is unreachable, not ungated. */
const DENY_ALL: Access = () => false;

/**
 * The access map with every flag-pruned destination removed. Use this instead of importing
 * {@link ACCESS_MAP} directly, so the nav, the route guard and the landing redirect all read the
 * same pruned map and cannot disagree about which destinations exist.
 *
 * <p>Must be called below the provider that holds the flags, which {@code CurrentUser} mounts.
 * Above it the flag map is empty, every negated flag reads as satisfied, and pruned destinations
 * come back. That failure is silent, because a kept destination looks exactly like a correct one.
 */
export const useAccessMap = (): Readonly<AppDestination[]> =>
  useFeatureFlagFilter(ACCESS_MAP);

/** The gate for one destination, or a closed gate when the flag has pruned it. */
export const useDestinationAccess = (key: string): Access =>
  useAccessMap().find((destination) => destination.key === key)?.canAccess ??
  DENY_ALL;
